import { LanguageDetectorAsyncModule } from 'i18next';

const FALLBACK_LOCALE = 'en-US';

class LanguageDetector implements LanguageDetectorAsyncModule {
  public readonly async = true;
  public readonly type = 'languageDetector';

  private localeToLanguageTag(locale: string) {
    const toks = locale.split('_');

    if (toks.length !== 2) {
      return FALLBACK_LOCALE;
    }

    return `${toks[0]}-${toks[1]}`;
  }

  detect(callback: (languageTag: string) => void) {
    const languageTag =
      window.AppContext && window.AppContext.locale && typeof window.AppContext.locale === 'string'
        ? this.localeToLanguageTag(window.AppContext.locale)
        : FALLBACK_LOCALE;
    callback(languageTag);
  }

  cacheUserLanguage(): void {
    // do nothing
  }

  init(): void {
    // do nothing
  }
}

export default LanguageDetector;
